"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.title = exports.scroll = exports.horizontalSlide = void 0;
var _core = require("@emotion/core");
var commonStyles = _interopRequireWildcard(require("../common.style"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var horizontalSlide = exports.horizontalSlide = {
  name: "c7ak1b",
  styles: "margin:0;display:flex;justify-content:space-between;"
};
var scroll = exports.scroll = {
  name: "bg7p2q",
  styles: "justify-content:flex-start;gap:30px;overflow-x:auto;padding-right:14px;"
};
var title = exports.title = commonStyles.mainTitle;